import React, { useState, useEffect, useRef } from 'react';
import { supabase } from '../../lib/supabase';
import { useNavigate, useSearchParams, useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useData } from '../../contexts/DataContext';
import AdminLayout from '../../components/AdminLayout';
import PDFImporter from '../../components/PDFImporter';
import { GRUPO_POR_TEMPLATE, montarExerciciosDoTreino } from '../../lib/bibliotecaTreinos';
import { GRUPOS_MUSCULARES } from '../../lib/gruposMusculares';

const GRUPOS = GRUPOS_MUSCULARES;
const POSICOES_PES = ['Pés paralelos','Pés em abdução (sumo)','Pés paralelos e em abdução','Pontas de pé para cima','Pés levemente abertos','—'];
const POSICOES_MAOS = ['Mãos supinadas (palmas para cima)','Mãos pronadas (palmas para baixo)','Mãos neutras (palmas opostas)','Pegada fechada (triângulo)','Pegada aberta','—'];

const s = {
  page: { maxWidth: 860 },
  h1: { fontFamily:"'Inter', sans-serif", fontSize: 34, fontWeight: 700, color: 'var(--text)', marginBottom: 4 },
  h1em: { fontStyle:'italic', color: 'var(--accent)' },
  sub: { fontSize: 13, color: 'var(--text-2)', marginBottom: 28 },
  card: { background: 'var(--surface)', border: '1px solid var(--divider)', borderRadius: 'var(--r-card)', padding: '24px 28px', marginBottom: 16, boxShadow: 'var(--sh-card)' },
  cardTitle: { fontSize: 11, fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'var(--accent)', marginBottom: 16 },
  grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 },
  grid3: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 14 },
  label: { display: 'block', fontSize: 11, fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--text-3)', marginBottom: 5 },
  input: { width: '100%', padding: '9px 12px', border: '1.5px solid var(--divider)', borderRadius: 'var(--r-input)', fontSize: 13, color: 'var(--text)', background: 'var(--surface)', outline: 'none', boxSizing: 'border-box', fontFamily:"'Inter',sans-serif" },
  textarea: { width: '100%', padding: '9px 12px', border: '1.5px solid var(--divider)', borderRadius: 'var(--r-input)', fontSize: 13, color: 'var(--text)', background: 'var(--surface)', outline: 'none', boxSizing: 'border-box', fontFamily:"'Inter',sans-serif", resize: 'vertical', minHeight: 72 },
  select: { width: '100%', padding: '9px 12px', border: '1.5px solid var(--divider)', borderRadius: 'var(--r-input)', fontSize: 13, color: 'var(--text)', background: 'var(--surface)', outline: 'none', boxSizing: 'border-box' },
  exCard: { background: 'var(--bg)', border: '1px solid var(--divider)', borderRadius: 'var(--r-card)', padding: '18px 20px', marginBottom: 10 },
  exHeader: { display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 },
  exNum: { fontFamily:"'Inter', sans-serif", fontSize: 20, fontWeight: 700, color: 'var(--accent)', minWidth: 28 },
  removeBtn: { padding: '4px 10px', background: 'transparent', border: '1px solid rgba(229,57,53,0.25)', color: '#E53935', borderRadius: 'var(--r-btn)', fontSize: 11, cursor: 'pointer' },
  modeRow: { display: 'flex', gap: 6, marginBottom: 14 },
  modeBtn: { flex: 1, padding: '8px 4px', border: '1.5px solid var(--divider)', borderRadius: 'var(--r-btn)', fontSize: 12, fontWeight: 600, cursor: 'pointer', textAlign: 'center', background: 'transparent', color: 'var(--text-3)', fontFamily:"'Inter',sans-serif" },
  modeBtnActive: { background: 'var(--text)', color: '#FAF7F2', borderColor: 'var(--text)' },
  addExBtn: { width: '100%', padding: '11px', border: '1.5px dashed rgba(137,91,64,0.3)', borderRadius: 'var(--r-btn)', background: 'transparent', color: 'var(--accent)', fontSize: 13, fontWeight: 600, cursor: 'pointer' },
  saveBtn: { padding: '13px 40px', background: 'var(--text)', color: '#FAF7F2', border: 'none', borderRadius: 'var(--r-btn)', fontSize: 13, fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', cursor: 'pointer' },
  cancelBtn: { padding: '13px 24px', background: 'transparent', border: '1px solid var(--divider)', color: 'var(--text-2)', borderRadius: 'var(--r-btn)', fontSize: 13, cursor: 'pointer', marginRight: 10 },
  mdBox: { border: '1.5px dashed rgba(137,91,64,0.35)', borderRadius: 'var(--r-card)', padding: '20px 24px', background: 'rgba(137,91,64,0.03)', cursor: 'pointer', textAlign: 'center' },
  mdStatus: { marginTop: 10, padding: '10px 14px', background: 'rgba(137,91,64,0.07)', border: '1px solid rgba(137,91,64,0.2)', borderRadius: 'var(--r-btn)', fontSize: 12, color: 'var(--accent)' },
  success: { padding: '12px 16px', background: 'rgba(76,175,80,0.07)', border: '1px solid rgba(76,175,80,0.25)', color: '#2E7D32', borderRadius: 'var(--r-btn)', fontSize: 13, marginBottom: 16 },
  templateBanner: { padding: '12px 16px', background: 'rgba(137,91,64,0.07)', border: '1px solid rgba(137,91,64,0.25)', color: 'var(--accent)', borderRadius: 'var(--r-btn)', fontSize: 12.5, lineHeight: 1.6, marginBottom: 16 },
  importBtn: { marginTop: 10, padding: '10px 24px', background: 'var(--text)', color: '#FAF7F2', border: 'none', borderRadius: 'var(--r-btn)', fontSize: 12, fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', cursor: 'pointer' },
};

function novoEx(i) {
  return { id: 'ex_' + Date.now() + '_' + i, nome: '', grupo: '', modo: 'tempo', series: '4', execucaoSeg: '30', descansaSeg: '30', reps: '', carga: '', obs: '', posicaoPes: '', posicaoMaos: '', video: '' };
}

export default function CadastrarTreino() {
  const { alunas } = useAuth();
  const { treinos, salvarTreino, treinosBiblioteca } = useData();
  const navigate = useNavigate();
  const { id: treinoIdRota } = useParams();
  const [params] = useSearchParams();
  const fileRef = useRef();
  const templateAplicadoRef = useRef(false);
  const treinoCarregadoRef = useRef(false);
  const [templateOrigem, setTemplateOrigem] = React.useState(null);
  const editando = Boolean(treinoIdRota);
  const [sugestoes, setSugestoes] = React.useState([]);
  const [sugestaoIdx, setSugestaoIdx] = React.useState(-1);
  const [activeNomeIdx, setActiveNomeIdx] = React.useState(null);

  async function buscarSugestoes(termo, idx) {
    setActiveNomeIdx(idx);
    if (!termo || termo.length < 2) { setSugestoes([]); return; }
    const { data } = await supabase
      .from('exercicios_biblioteca')
      .select('nome, grupo_muscular, video_url')
      .ilike('nome', '%' + termo + '%')
      .limit(8);
    setSugestoes(data || []);
    setSugestaoIdx(-1);
  }

  function selecionarSugestao(idx, sug) {
    setEx(idx, 'nome', sug.nome);
    if (sug.grupo_muscular) setEx(idx, 'grupo', sug.grupo_muscular);
    if (sug.video_url) setEx(idx, 'video', sug.video_url);
    setSugestoes([]);
    setActiveNomeIdx(null);
  }

  const [ficha, setFicha] = useState({
    id: '',
    alunaId: params.get('aluna') || '',
    titulo: '', descricao: '', obs: '',
    grupo: '', semana: '1', ordem: '1',
    objetivo: '', dataInicio: '', dataAjuste: '', dataAnalise: '',
    instrucoes: '',
    exercicios: [novoEx(0)],
  });

  const [mdTexto, setMdTexto] = useState('');
  const [mdStatus, setMdStatus] = useState('');
  const [importando, setImportando] = useState(false);
  const [salvo, setSalvo] = useState(false);

  useEffect(() => {
    const templateId = params.get('template');
    if (!templateId || templateAplicadoRef.current || !treinosBiblioteca?.length) return;
    const treino = treinosBiblioteca.find(t => t.id === templateId);
    if (!treino) return;
    templateAplicadoRef.current = true;

    const exercicios = montarExerciciosDoTreino(treino, treinosBiblioteca);

    setFicha(f => ({
      ...f,
      titulo: treino.titulo,
      grupo: GRUPO_POR_TEMPLATE[treino.id] || f.grupo,
      instrucoes: treino.instrucoes || f.instrucoes,
      exercicios: exercicios.length ? exercicios : f.exercicios,
    }));
    setTemplateOrigem(treino);
  }, [params, treinosBiblioteca]);

  useEffect(() => {
    if (!treinoIdRota || treinoCarregadoRef.current || !treinos?.length) return;
    const treino = treinos.find(t => t.id === treinoIdRota);
    if (!treino) return;
    treinoCarregadoRef.current = true;

    setFicha(f => ({
      ...f,
      id: treino.id,
      alunaId: treino.alunaId || treino.aluna_id || f.alunaId,
      titulo: treino.titulo || '',
      descricao: treino.descricao || '',
      obs: treino.obs || '',
      semana: String(treino.semana || 1),
      ordem: String(treino.ordem || 1),
      objetivo: treino.objetivo || '',
      dataInicio: treino.data_inicio || treino.dataInicio || '',
      dataAjuste: treino.data_ajuste || treino.dataAjuste || '',
      dataAnalise: treino.data_analise || treino.dataAnalise || '',
      instrucoes: treino.instrucoes || treino.obs || '',
      exercicios: treino.exercicios && treino.exercicios.length ? treino.exercicios : f.exercicios,
    }));
  }, [treinoIdRota, treinos]);

  const set = (k, v) => setFicha(f => ({ ...f, [k]: v }));

  const setEx = (i, k, v) => setFicha(f => {
    const exs = [...f.exercicios];
    exs[i] = { ...exs[i], [k]: v };
    return { ...f, exercicios: exs };
  });

  const addEx = () => setFicha(f => ({ ...f, exercicios: [...f.exercicios, novoEx(f.exercicios.length)] }));
  const removeEx = (i) => setFicha(f => ({ ...f, exercicios: f.exercicios.filter((_, j) => j !== i) }));

  function lerArquivoMd(file) {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = function(e) { setMdTexto(e.target.result); };
    reader.readAsText(file);
  }

  function aplicarDadosImportados(parsed) {
    setFicha(f => ({
      ...f,
      titulo: parsed.titulo || f.titulo,
      grupo: parsed.grupo || f.grupo,
      objetivo: parsed.objetivo || f.objetivo,
      dataInicio: parsed.dataInicio || f.dataInicio,
      dataAjuste: parsed.dataAjuste || f.dataAjuste,
      dataAnalise: parsed.dataAnalise || f.dataAnalise,
      instrucoes: parsed.instrucoes || f.instrucoes,
      exercicios: parsed.exercicios && parsed.exercicios.length
        ? parsed.exercicios.map(function(ex, i) { return Object.assign({}, novoEx(i), ex, { id: 'ex_' + Date.now() + '_' + i }); })
        : f.exercicios,
    }));
    return parsed.exercicios ? parsed.exercicios.length : 0;
  }

  async function importarMd() {
    if (!mdTexto.trim()) return;
    setImportando(true);
    setMdStatus('Processando...');
    try {
      const resp = await fetch('/.netlify/functions/extrair-md', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mdTexto })
      });

      const parsed = await resp.json();
      if (!resp.ok) throw new Error(parsed.error || 'Erro na function');

      const total = aplicarDadosImportados(parsed);
      setMdStatus('✓ ' + total + ' exercícios importados. Revise antes de salvar.');
    } catch (err) {
      console.error(err);
      setMdStatus('Erro ao processar: ' + err.message);
    }
    setImportando(false);
  }

  function importarPdf(parsed) {
    const total = aplicarDadosImportados(parsed);
    setMdStatus('✓ ' + total + ' exercícios importados. Revise antes de salvar.');
  }

  async function handleSalvar(e) {
    e.preventDefault();
    if (!ficha.alunaId || !ficha.titulo) return;
    await salvarTreino({
      id: ficha.id || undefined,
      alunaId: ficha.alunaId,
      titulo: ficha.titulo,
      descricao: ficha.descricao || ficha.grupo,
      obs: ficha.instrucoes || ficha.obs,
      semana: parseInt(ficha.semana) || 1,
      ordem: parseInt(ficha.ordem) || 1,
      objetivo: ficha.objetivo,
      dataInicio: ficha.dataInicio,
      dataAjuste: ficha.dataAjuste,
      dataAnalise: ficha.dataAnalise,
      instrucoes: ficha.instrucoes,
      exercicios: ficha.exercicios,
    });
    setSalvo(true);
    setTimeout(function() { navigate(editando ? '/admin/treinos' : '/admin/alunas'); }, 1800);
  }

  return (
    <AdminLayout>
      <div style={s.page}>
        {editando ? (
          <>
            <h1 style={s.h1}>Editar <em style={s.h1em}>treino</em></h1>
            <p style={s.sub}>Ajuste exercícios, cargas, observações ou instruções desta ficha. As alterações valem só para esta aluna.</p>
          </>
        ) : (
          <>
            <h1 style={s.h1}>Cadastrar <em style={s.h1em}>treino</em></h1>
            <p style={s.sub}>Importe uma ficha em Markdown ou preencha manualmente.</p>
          </>
        )}

        {salvo && <div style={s.success}>✓ Treino salvo com sucesso!</div>}

        {templateOrigem && (
          <div style={s.templateBanner}>
            📚 Baseado no treino da biblioteca: <strong>{templateOrigem.titulo}</strong> ({templateOrigem.protocolo === '30x30' ? 'Protocolo 30x30' : templateOrigem.protocolo === 'definicao4s' ? 'Definição · 4 semanas' : 'Protocolo Moderado'}).
            Revise e ajuste os campos abaixo antes de salvar para a aluna.
          </div>
        )}

        <form onSubmit={handleSalvar}>

          <div style={s.card}>
            <div style={s.cardTitle}>Importar ficha (.md)</div>
            <div style={s.mdBox} onClick={() => fileRef.current && fileRef.current.click()}
              onDragOver={e => e.preventDefault()}
              onDrop={e => { e.preventDefault(); lerArquivoMd(e.dataTransfer.files[0]); }}>
              <input ref={fileRef} type="file" accept=".md,.txt" style={{ display: 'none' }}
                onChange={e => lerArquivoMd(e.target.files[0])} />
              <span style={{ fontSize: 13, color: '#5B402E' }}>
                {mdTexto ? '✓ Arquivo carregado — clique em Importar' : 'Clique ou arraste o arquivo .md aqui'}
              </span>
            </div>
            {mdTexto && !mdStatus && (
              <button type="button" style={s.importBtn} onClick={importarMd} disabled={importando}>
                {importando ? 'Processando...' : 'Importar treino'}
              </button>
            )}
            {mdStatus && <div style={s.mdStatus}>{mdStatus}</div>}
          </div>

          <div style={s.card}>
            <div style={s.cardTitle}>Importar ficha (PDF)</div>
            <PDFImporter tipo="treino" onImport={importarPdf} />
          </div>

          <div style={s.card}>
            <div style={s.cardTitle}>Identificação</div>
            <div style={{ ...s.grid2, marginBottom: 14 }}>
              <div>
                <label style={s.label}>Aluna</label>
                <select style={s.select} value={ficha.alunaId} onChange={e => set('alunaId', e.target.value)} required>
                  <option value="">Selecionar aluna</option>
                  {(alunas || []).filter(a => a.status === 'ativa').map(a => (
                    <option key={a.id} value={a.id}>{a.name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={s.label}>Objetivo</label>
                <input style={s.input} value={ficha.objetivo} onChange={e => set('objetivo', e.target.value)} placeholder="Ex: Fortalecimento / Emagrecimento" />
              </div>
            </div>
            <div style={{ ...s.grid3, marginBottom: 14 }}>
              <div>
                <label style={s.label}>Título do treino</label>
                <input style={s.input} value={ficha.titulo} onChange={e => set('titulo', e.target.value)} placeholder="Ex: Treino A — Quadríceps" required />
              </div>
              <div>
                <label style={s.label}>Grupo muscular</label>
                <select style={s.select} value={ficha.grupo} onChange={e => set('grupo', e.target.value)}>
                  <option value="">Selecionar</option>
                  {GRUPOS.map(g => <option key={g} value={g}>{g}</option>)}
                </select>
              </div>
              <div>
                <label style={s.label}>Semana</label>
                <input style={s.input} type="number" min="1" value={ficha.semana} onChange={e => set('semana', e.target.value)} />
              </div>
            </div>
            <div style={s.grid3}>
              <div>
                <label style={s.label}>Data início</label>
                <input style={s.input} type="date" value={ficha.dataInicio} onChange={e => set('dataInicio', e.target.value)} />
              </div>
              <div>
                <label style={s.label}>Data ajuste</label>
                <input style={s.input} type="date" value={ficha.dataAjuste} onChange={e => set('dataAjuste', e.target.value)} />
              </div>
              <div>
                <label style={s.label}>Data análise</label>
                <input style={s.input} type="date" value={ficha.dataAnalise} onChange={e => set('dataAnalise', e.target.value)} />
              </div>
            </div>
          </div>

          <div style={s.card}>
            <div style={s.cardTitle}>Instruções gerais</div>
            <textarea style={s.textarea} value={ficha.instrucoes} onChange={e => set('instrucoes', e.target.value)}
              placeholder="Orientações gerais para a aluna sobre este bloco de treino..." rows={4} />
          </div>

          <div style={s.card}>
            <div style={s.cardTitle}>{ficha.exercicios.length} exercício{ficha.exercicios.length !== 1 ? 's' : ''}</div>

            {ficha.exercicios.map((ex, idx) => (
              <div key={ex.id} style={s.exCard}>
                <div style={s.exHeader}>
                  <span style={s.exNum}>{String(idx + 1).padStart(2, '0')}</span>
                  <span style={{ flex: 1, fontSize: 14, fontWeight: 600, color: '#251C19' }}>{ex.nome || 'Exercício'}</span>
                  {ficha.exercicios.length > 1 && (
                    <button type="button" style={s.removeBtn} onClick={() => removeEx(idx)}>Remover</button>
                  )}
                </div>

                <div style={{ ...s.grid2, marginBottom: 12 }}>
                  <div style={{ position: 'relative' }}>
                    <label style={s.label}>Nome do exercício</label>
                    <input style={s.input} value={ex.nome}
                      onChange={e => { setEx(idx, 'nome', e.target.value); buscarSugestoes(e.target.value, idx); }}
                      onBlur={() => setTimeout(() => setSugestoes([]), 200)}
                      placeholder="Ex: Cadeira extensora" autoComplete="off" />
                    {activeNomeIdx === idx && sugestoes.length > 0 && (
                      <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'var(--surface)', border: '1.5px solid rgba(137,91,64,0.3)', borderRadius: 'var(--r-input)', zIndex: 100, boxShadow: '0 4px 16px rgba(0,0,0,0.1)', maxHeight: 220, overflowY: 'auto' }}>
                        {sugestoes.map((sug, si) => (
                          <div key={si} onMouseDown={() => selecionarSugestao(idx, sug)}
                            style={{ padding: '9px 14px', cursor: 'pointer', fontSize: 13, color: '#251C19', borderBottom: '1px solid rgba(37,28,25,0.06)', background: si === sugestaoIdx ? 'rgba(137,91,64,0.07)' : 'transparent' }}>
                            <div style={{ fontWeight: 600 }}>{sug.nome}</div>
                            {sug.grupo_muscular && <div style={{ fontSize: 11, color: '#5B402E', marginTop: 2 }}>{sug.grupo_muscular}</div>}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div>
                    <label style={s.label}>Grupo muscular</label>
                    <select style={s.select} value={ex.grupo} onChange={e => setEx(idx, 'grupo', e.target.value)}>
                      <option value="">Selecionar</option>
                      {GRUPOS.map(g => <option key={g} value={g}>{g}</option>)}
                    </select>
                  </div>
                </div>

                <label style={s.label}>Modo de série</label>
                <div style={s.modeRow}>
                  <button type="button" style={{ ...s.modeBtn, ...(ex.modo === 'tempo' ? s.modeBtnActive : {}) }}
                    onClick={() => setEx(idx, 'modo', 'tempo')}>⏱ Tempo (30/30)</button>
                  <button type="button" style={{ ...s.modeBtn, ...(ex.modo === 'reps' ? s.modeBtnActive : {}) }}
                    onClick={() => setEx(idx, 'modo', 'reps')}>🔢 Repetições</button>
                </div>

                {ex.modo === 'tempo' ? (
                  <div style={{ ...s.grid3, marginBottom: 12 }}>
                    <div><label style={s.label}>Séries</label><input style={s.input} value={ex.series} onChange={e => setEx(idx, 'series', e.target.value)} placeholder="4" /></div>
                    <div><label style={s.label}>Execução (seg)</label><input style={s.input} type="number" value={ex.execucaoSeg} onChange={e => setEx(idx, 'execucaoSeg', e.target.value)} placeholder="30" /></div>
                    <div><label style={s.label}>Descanso (seg)</label><input style={s.input} type="number" value={ex.descansaSeg} onChange={e => setEx(idx, 'descansaSeg', e.target.value)} placeholder="30" /></div>
                  </div>
                ) : (
                  <div style={{ ...s.grid3, marginBottom: 12 }}>
                    <div><label style={s.label}>Séries</label><input style={s.input} value={ex.series} onChange={e => setEx(idx, 'series', e.target.value)} placeholder="4" /></div>
                    <div><label style={s.label}>Repetições</label><input style={s.input} value={ex.reps} onChange={e => setEx(idx, 'reps', e.target.value)} placeholder="12" /></div>
                    <div><label style={s.label}>Descanso (seg)</label><input style={s.input} type="number" value={ex.descansaSeg} onChange={e => setEx(idx, 'descansaSeg', e.target.value)} placeholder="60" /></div>
                  </div>
                )}

                <div style={{ marginBottom: 12 }}>
                  <label style={s.label}>Carga</label>
                  <input style={s.input} value={ex.carga} onChange={e => setEx(idx, 'carga', e.target.value)} placeholder="Ex: Leve e ao final moderada" />
                </div>

                <div style={{ ...s.grid2, marginBottom: 12 }}>
                  <div>
                    <label style={s.label}>Posicionamento dos pés</label>
                    <select style={s.select} value={ex.posicaoPes} onChange={e => setEx(idx, 'posicaoPes', e.target.value)}>
                      <option value="">Selecionar</option>
                      {POSICOES_PES.map(p => <option key={p} value={p}>{p}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={s.label}>Posicionamento das mãos</label>
                    <select style={s.select} value={ex.posicaoMaos} onChange={e => setEx(idx, 'posicaoMaos', e.target.value)}>
                      <option value="">Selecionar</option>
                      {POSICOES_MAOS.map(p => <option key={p} value={p}>{p}</option>)}
                    </select>
                  </div>
                </div>

                <div style={{ marginBottom: 12 }}>
                  <label style={s.label}>Observação da Carol</label>
                  <textarea style={s.textarea} value={ex.obs} onChange={e => setEx(idx, 'obs', e.target.value)} placeholder="Instrução de execução para a aluna..." rows={2} />
                </div>

                <div>
                  <label style={s.label}>Link do vídeo (YouTube)</label>
                  <input style={s.input} value={ex.video} onChange={e => setEx(idx, 'video', e.target.value)} placeholder="https://youtube.com/watch?v=..." />
                </div>
              </div>
            ))}

            <button type="button" style={s.addExBtn} onClick={addEx}>+ Adicionar exercício</button>
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
            <button type="button" style={s.cancelBtn} onClick={() => navigate('/admin/alunas')}>Cancelar</button>
            <button type="submit" style={s.saveBtn}>Salvar treino</button>
          </div>

        </form>
      </div>
    </AdminLayout>
  );
}
